export const FormField = ({ label, required, error, errorId, children, hint, labelClassName = '' }) => (
  <label className='block'>
    <span className={`mb-1.5 block text-sm font-semibold text-[var(--text-secondary)] ${labelClassName}`}>
      {label}
      {required && <span className='ml-1 text-[var(--danger)]'>*</span>}
    </span>
    {children}
    {error ? (
      <span id={errorId} className='mt-1.5 block text-xs text-[var(--danger)]'>{error}</span>
    ) : hint ? (
      <span className='mt-1.5 block text-xs text-[var(--text-muted)]'>{hint}</span>
    ) : null}
  </label>
);

export const inputClassName =
  'w-full rounded-[var(--radius-md)] border border-[var(--border-subtle)] bg-[var(--surface-panel)] px-3 py-2.5 text-sm text-[var(--text-primary)] placeholder:text-[var(--text-muted)] shadow-sm focus:border-[var(--brand)] dark:[color-scheme:dark]';
